import httpClient from '@/http-client'

export const get = (options = {}) => {
  return httpClient
    .get('/api/monthly-attendnce', options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}
export const department = (Options = {}) => {
  return httpClient
    .get('/api/monthly-attendnce/departments', Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}
export const employee = (Options = {}) => {
  return httpClient
    .get('/api/monthly-attendnce/employees', Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}
export const position = (Options = {}) => {
  return httpClient
    .get('/api/monthly-attendnce/positions', Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}
export const header = (Options = {}) => {
  return httpClient
    .get('/api/monthly-attendnce/get-header', Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const holiday = (Options = {}) => {
  return httpClient
    .get('/api/monthly-attendnce/holidays', Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}
export const exportExcel = attributes => {
  return httpClient
    .post('/api/monthly-attendnce/export-excel', attributes, {
      responseType: 'arraybuffer'
    })
    .then(response => Promise.resolve(response))
    .catch(error => Promise.reject(error.response.data))
}
export default {
  department,
  employee,
  position,
  header,
  get,
  holiday,
  exportExcel
}
